import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-there-are-no-products-to-display',
  templateUrl: './dialog-there-are-no-products-to-display.component.html',
  styleUrls: ['./dialog-there-are-no-products-to-display.component.css']
})
export class DialogThereAreNoProductsToDisplayComponent implements OnInit {

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  onCloseDialog(): void {
    this.dialog.closeAll();
  }

}
